import ReactLoading from "react-loading";
import Backdrop from "@mui/material/Backdrop";
// import Redux
import {  useSelector,useDispatch } from 'react-redux';
import { RootState } from '../store/reducers';
import { actionCreators } from "../store";
import { bindActionCreators } from "redux";

export default function FreezScreen() {
    const state = useSelector((state: RootState) => state.appReducer)
    const dispatch = useDispatch();
    const {
      freezScreenState,
      setExtrasFieldsPopup
    } = bindActionCreators(actionCreators, dispatch);
    const handleCloseAll =()=>{
      freezScreenState(false);
      setExtrasFieldsPopup(false)
    }
  return (
    <Backdrop
    sx={{ color: "#fff", zIndex: (theme:any) => theme.zIndex.drawer + 99999 }}
    open={state.freezScreen}
    onClick={handleCloseAll}
    
     >
      <ReactLoading className="mx-auto" type="bars" color="#eb5b5e" />
    </Backdrop>
  );
}
